const Confirm = function (data) {
  // console.dir(this)

  // Get the values from the form
  // this.editUser.resetEditUserModal()

  // Store changes
  this.editUser.storeChanges(data)
}

export default Confirm
